import React from "react";
import styled from "styled-components";
import {Route, Switch} from "react-router-dom";
import EqualityHealth from "../../img/eqlogo.jpg";
import AuthBg from "../../img/ce-authbg.jpg";
import {Container} from "react-bootstrap";

import ResetPasswordView from "./ResetPassword";
import RecoverPassword from "./RecoverPassword";
import VerifyCode from "./VerifyCode";
import Message from "../admin/broadcastMessenger/message";
import Login from "./Login";

const componentName = "DefaultLogin";

const AuthPage = styled(Container)`
  width: 100%;
  height: 100%;
  background: url(${AuthBg});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
`;

const UnbrandedLogin = () => {
  return (
    <AuthPage fluid className="justify-content-center justify-content-sm-start p-0">
      <div className="w-25 mw-400 h-100 bg-white p-5 d-flex justify-content-center align-items-center">
        <div id={`${componentName}-login`} className="authbox">
          <Message className="mb-5" />
          <div id={`${componentName}-logo`} className="text-center mb-3">
            <img src={EqualityHealth} id={`${componentName}-EQlogoImage`} height={40} alt="Equality Health Logo" />
          </div>
          <Switch>
            <Route path="/recover-password" component={RecoverPassword} />
            <Route path="/reset-password/:token" component={ResetPasswordView} />
            <Route path="/verify" component={VerifyCode} />
            {/* Login is the last route in this list (and without a path) to make sure it's displayed if no other matching routes */}
            <Route component={Login} />
          </Switch>
        </div>
      </div>
      <div className="vh-100 w-75 d-none d-md-block">
        &nbsp;
      </div>
    </AuthPage>
  );
};

export default UnbrandedLogin;
